export const SAVE_PERMISSION = "SAVE_PERMISSION";
export const LIST_PERMISSION = "LIST_PERMISSION";
export const SAVE_MOBILE_VIEW = "SAVE_MOBILE_VIEW";
export const SAVE_USER_DETAILS = "SAVE_USER_DETAILS";
export const SAVE_SUB_GROUPS = "SAVE_SUB_GROUPS";

